import { createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6e434100")

_pushScopeId("data-v-6e434100")
const _hoisted_1 = { class: "qty-report-modal" }
const _hoisted_2 = { class: "container main-qty-report-container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-8 item-title" }
const _hoisted_5 = { class: "col-4 item-title" }
const _hoisted_6 = {
  style: {"line-height":"28px"},
  class: "col-8"
}
const _hoisted_7 = {
  style: {"line-height":"28px"},
  class: "col-4"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_OverlayModal = _resolveComponent("OverlayModal")

  return (_openBlock(), _createBlock(_component_OverlayModal, {
    isOpen: _ctx.isOpen,
    "onUpdate:isOpen": _cache[2] || (_cache[2] = ($event: any) => (_ctx.isOpen = $event)),
    contentClass: "modal-limit",
    style: {"max-heigth":"90vh"}
  }, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("span", {
          class: "icon-f icon-delete-cross fs-16 close-qty-report",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isOpen = false))
        }),
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('orders-qty-report-customer')), 1),
            _createVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('orders-qty-report-qty')), 1)
          ]),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.Items, (item) => {
            return (_openBlock(), _createBlock("div", {
              class: "row order-customer-items",
              key: item.customerTypeId
            }, [
              _createVNode("div", _hoisted_6, _toDisplayString(item.name), 1),
              _createVNode("div", _hoisted_7, _toDisplayString(item.qty), 1)
            ]))
          }), 128))
        ])
      ])
    ]),
    _: 1
  }, 8, ["isOpen"]))
})